import React from "react";
import { Box, Typography } from "@mui/material";
import Check from "@mui/icons-material/Check";
import { useTranslation } from "react-i18next";
import { passwordRequirements } from "utils/passwordValidation";

// passwordRequirements' labels are English; these are their keys under password.requirements.
const REQUIREMENT_KEYS = [
  "minLength",
  "uppercase",
  "lowercase",
  "number",
  "special",
];

// Brand colors, not a red-to-green traffic light: a requirement goes from grey to
// primary as it's met, and the bar fills in primary.
const PasswordRequirements = ({ value = "", sx = {} }) => {
  const { t } = useTranslation("account");
  const hasInput = value.length > 0;
  const metCount = passwordRequirements.filter(({ test }) =>
    test(value),
  ).length;
  const total = passwordRequirements.length;
  const barWidth = hasInput ? (metCount / total) * 100 : 0;

  return (
    <Box sx={{ ...sx }}>
      {/* Strength bar */}
      <Box
        sx={{
          height: 4,
          borderRadius: 2,
          bgcolor: "action.selected",
          overflow: "hidden",
          mb: 1.5,
        }}
      >
        <Box
          sx={{
            height: "100%",
            width: `${barWidth}%`,
            bgcolor: "primary.main",
            borderRadius: 2,
            transition: "width 0.25s ease, background-color 0.25s ease",
          }}
        />
      </Box>

      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ display: "block", mb: 1 }}
      >
        {t("password.requirements.title")}
      </Typography>

      {/* Requirements list */}
      {passwordRequirements.map(({ label, test }, index) => {
        const met = hasInput && test(value);
        return (
          <Box
            key={label}
            sx={{ display: "flex", alignItems: "center", gap: 0.75, mb: 0.5 }}
          >
            <Check
              sx={{
                fontSize: 13,
                color: met ? "primary.main" : "text.disabled",
                flexShrink: 0,
              }}
            />
            <Typography
              variant="caption"
              color={met ? "primary.main" : "text.secondary"}
            >
              {REQUIREMENT_KEYS[index]
                ? t(`password.requirements.${REQUIREMENT_KEYS[index]}`)
                : label}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

export default PasswordRequirements;
